import React, { useState, useEffect } from "react";
import queryString from "query-string";

import ShareIcon from "@mui/icons-material/Share";
import { GenerateScontrinoUrl } from "../../functions/saveScontrinoUrl";

const SaveButton = ({ fatturato, cassaCoeff, ibridoCase }) => {
  const location = window.location;
  const urlParameters = queryString.parse(location.search);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsClicked(false);
    }, 2000);
  }, [isClicked]);

  const handleClick = () => {
    setIsClicked(true);

    navigator.clipboard.writeText(
      `${location.origin}${GenerateScontrinoUrl(
        urlParameters,
        fatturato,
        cassaCoeff,
        ibridoCase
      )}`
    );
  };

  return (
    <>
      <button
        onClick={() => handleClick()}
        className="border border-orange-400 dark:border-white px-8 py-2 text-white bg-orange-400 rounded-md hover:shadow-lg duration-200 flex flex-row items-center gap-x-2"
      >
        <ShareIcon />
        {isClicked ? "URL copiato!" : "Condividi"}
      </button>
    </>
  );
};

export default SaveButton;
